/**
 * @generated SignedSource<<fda4d65fddb2dc168ce8f90a0f33ed33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportCustomProfileFieldsTableRowFragment$data = {
  readonly title: string;
  readonly webFormQuestion: {
    readonly " $fragmentSpreads": FragmentRefs<"WebFormQuestionResponseTableFieldFragment" | "WebFormQuestionTableFieldFragment" | "WebFormQuestionTypeTableFieldFragment">;
  } | null;
  readonly " $fragmentType": "AdminMembersReportCustomProfileFieldsTableRowFragment";
};
export type AdminMembersReportCustomProfileFieldsTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportCustomProfileFieldsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportCustomProfileFieldsTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportCustomProfileFieldsTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestion",
      "kind": "LinkedField",
      "name": "webFormQuestion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WebFormQuestionTypeTableFieldFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WebFormQuestionTableFieldFragment"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "organizationMembershipId",
              "variableName": "organizationMembershipId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "WebFormQuestionResponseTableFieldFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProfileField",
  "abstractKey": null
};

(node as any).hash = "5c1cc26361d9abd62fe54c1132bf6638";

export default node;
